import AntAuth from './AntAuth';

const FRESH_SERVICES = new Set([
    'Item', 'Variant', 'UOM', 'Warehouse', 'Store', 'SaleChannel',
    'ItemWarehouse', 'ItemSubstitute', 'ItemModifierProfile', 'ItemModifierGroup', 'ItemModifierItem', 'ItemShiftSlot',
    'ARPriceList', 'ARPriceListItem', 'ARPromotion', 'ARPromotionItem', 'ARPromotionX', 'ARPromotionY',
    'ServicePack', 'ServicePackItem', 'DepositPack',
    'ServePlace', 'ServeTable', 'ServeRoom', 'ServeSeat', 'ServeField',
    'ARItemStatus', 'ICInventory', 'ICInventoryLot', 'ICInventorySerial', 'ARServeStatus', 'RentalObject'
]);
const FRESH_SECONDS = 24 * 60 * 60;
function serviceName(value) {
    const parts = String(value || '').split('/').filter(Boolean);
    if (['list', 'detail', 'search', 'prepare'].includes(parts[parts.length - 1])) return parts[parts.length - 2] || '';
    return parts[parts.length - 1] || '';
}
function createdAtUnix() {
    const raw = AntAuth.getSessionInfo()?.business_created_at;
    if (typeof raw !== 'number' && !(typeof raw === 'string' && /^\d+$/.test(raw.trim()))) return null;
    const value = Number(raw);
    if (!Number.isFinite(value) || value <= 0) return null;
    return value >= 100000000000 ? Math.floor(value / 1000) : Math.floor(value);
}
function epoch(service) { return FRESH_SERVICES.has(serviceName(service)) ? createdAtUnix() : null; }
export default {
    isFresh(service) { const value = epoch(service); const now = Math.floor(Date.now() / 1000); return Boolean(value && now >= value && now < value + FRESH_SECONDS); },
    cacheGroup(group, service) { const value = epoch(service); return value ? `${group}-onboarding-${value}` : group; }
};
